module.exports = __webpack_public_path__ + "static/img/qzmyH5.d86d628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qzmyH5.png
// module id = 2K0+
// module chunks = 1